import React, { useState } from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { Button } from 'antd'
import { map } from 'lodash'
import FooterButtons from '../../common/components/FooterButtons'
import { Gender, genderLabels } from '../ntfHelper'

export interface INtfLevelGenderChooserProps {
  hidden?: boolean
  levels: number[]
  loadingCards?: boolean
  minLevelGenderSelection: number
  pickLevelAndGender: (level: number, gender: Gender | undefined) => void
}


const NtfLevelGenderChooser = ({hidden, levels, loadingCards, minLevelGenderSelection, pickLevelAndGender}: INtfLevelGenderChooserProps) => {
  const [level, setLevel] = useState<number | undefined>(undefined)
  const [gender, setGender] = useState<Gender | undefined>(undefined)

  if (hidden) { return null }

  const readyToSubmit = level !== undefined && (level < minLevelGenderSelection || gender !== undefined) 

  const handleNext = () => {
    if (readyToSubmit) {
      const submitGender = level! >= minLevelGenderSelection ? gender : undefined
      pickLevelAndGender(level!, submitGender)
    }
  }

  const levelCols = levels.map((index) => {
    const buttonType = index === level ? 'primary' : 'default'
    return (
      <Col xs={12} sm={6} md={4} lg={3} key={`level-${index}`}>
        <Button disabled={loadingCards} size="large" block type={buttonType} onClick={() => setLevel(index)}>Level {index}</Button>
      </Col>
    )
  })

  const genderCols = map(genderLabels, (label, key) => {
    const buttonType = key === gender ? 'primary' : 'default'
    return (
      <Col xs={12} sm={6} md={4} lg={3} key={`level-${key}`}>
        <Button disabled={loadingCards} size="large" block type={buttonType} onClick={() => setGender(key as Gender)}>{label}</Button>
      </Col>
    )
  })

  const chooseGender = level && level >= minLevelGenderSelection ? (
    <>
      <h5 className="mt-4">Choose Category</h5>
      <Row>
        {genderCols}
      </Row>
    </>
  ): null

  return (
    <>
      <Container>
        <h4>Instructions</h4>
        <p>Choose a level to start.  Find all the matched sets or pairs in each activity. Work as quickly as you can, and see your score displayed after each exercise.</p>
        <h5>Choose Level</h5>
        <Row>
          {levelCols}
        </Row>
        {chooseGender}
      </Container>
      <FooterButtons 
        buttons={[{ disabled: !readyToSubmit, label: "Next", action: handleNext, buttonType: "primary", loading: loadingCards }]}
      />
    </>
  )
}

export default NtfLevelGenderChooser